// eslint-disable-next-line
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from 'Components';
import { AxiosCancelToken, axios, dataFetcher, endpoints, baseUrl } from 'Api';
import Google from '../../../../Assets/google.svg';
import styles from './index.module.css';

// `logoClassName` lets a page style the icon with its own stylesheet. The
// default below lives in the new-UI module, which is what this file imports;
// the classic login page passes its own class so the icon keeps the old size.
const GoogleLoginButton = ({ loginWithSocial, logoClassName }) => {
const login = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    console.log('Google Login Success:', tokenResponse);
    loginWithSocial(tokenResponse, 'google');
  },
  onError: () => {
    console.log('Google Login Failed');
  },
});

  return (
    <Button
      isGrayWhiteText
      isFullWidth
      alignCenter
      blockText
      onClick={login} // ✅ triggers Google login
      type="button"
    >
      <img className={logoClassName || styles.buttonLogoGoogle} src={Google} alt="Google" />
      Continue with Google
    </Button>
  );
};

export default GoogleLoginButton;
